import { Row } from "antd";
import styled from "styled-components";

export default styled(Row)`
  justify-content: flex-end;
  align-items: center;
  margin: 24px 0 12px 0;

  button {
    margin-left: 16px;
    min-width: 100px;
  }
`;

